<template>
  <div>
    <!-- Desktop arrows -->
    <div class="d-none d-lg-block">
      <div class="line-container-desktop-upper">
        <div class="horizontal-line-upper">
          <div class="vertical-line-upper start" />
          <div class="vertical-line-upper end" />
        </div>
      </div>
      <div class="line-container-desktop-lower">
        <div class="horizontal-line-lower">
          <div class="vertical-line-lower start" />
          <div class="vertical-line-lower upper-middle" />
          <div class="vertical-line-lower lower-middle" />
          <div class="vertical-line-lower end" />
        </div>
      </div>
    </div>

    <!-- Mobile arrows -->
    <span class="d-block d-lg-none">
      <span class="line-container-mobile-upper">
        <span class="vertical-line-upper">
          <span class="horizontal-line-upper top" />
          <span class="horizontal-line-upper middle" />
          <span class="horizontal-line-upper bottom" />
        </span>
      </span>
      <span class="line-container-mobile-lower">
        <span class="vertical-line-lower">
          <span class="horizontal-line-lower top" />
          <span class="horizontal-line-lower upper-middle" />
          <span class="horizontal-line-lower middle" />
          <span class="horizontal-line-lower lower-middle" />
          <span class="horizontal-line-lower bottom" />
        </span>
      </span>
    </span>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped>
.line-container-desktop-upper,
.line-container-desktop-lower {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35%;
  left: 15%;
  /* height: 30px; */
  z-index: 99;
}

.line-container-desktop-lower {
  width: 70%;
}

.horizontal-line-upper,
.horizontal-line-lower {
  position: relative;
  width: 100%;
  height: 2px;
  top: 12px;
  background-color: #9e9e9e;
}

.horizontal-line-lower {
  top: 235px;
}

.vertical-line-upper,
.vertical-line-lower {
  position: absolute;
  width: 2px;
  height: 10px;
  background-color: #9e9e9e;
}

.vertical-line-upper.start,
.vertical-line-lower.start {
  top: -35px;
  left: 0;
  height: 45px;
}

.vertical-line-lower.upper-middle {
  top: 0;
  height: 10px;
  left: 31%;
}

.vertical-line-lower.lower-middle {
  top: 0;
  height: 10px;
  left: 65%;
}

.vertical-line-upper.start::after,
.vertical-line-lower.start::after,
.vertical-line-lower.upper-middle::after,
.vertical-line-lower.lower-middle::after {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #9e9e9e;
  clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}

.vertical-line-upper.end,
.vertical-line-lower.end {
  top: 0;
  right: 0;
}

.vertical-line-upper.end::after,
.vertical-line-lower.end::after {
  content: '';
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #9e9e9e;
  clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}

@media (max-width: 960px) {
  .horizontal-arrow,
  .vertical-arrow {
    display: none;
  }
  .line-container-mobile-lower,
  .line-container-mobile-upper {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    height: 63.31%;
    left: 98%;
    top: 27.5%;
  }

  .line-container-mobile-upper {
    top: 3.5%;
    left: 1.5%;
    height: 33%;
  }

  .vertical-line-lower,
  .vertical-line-upper {
    position: relative;
    width: 2px;
    height: 100%;
    background-color: #9e9e9e;
  }

  .horizontal-line-lower,
  .horizontal-line-upper {
    position: absolute;
    width: 20px;
    height: 2px;
    background-color: #9e9e9e;
  }

  .horizontal-line-upper {
    width: 18px;
  }

  .horizontal-line-lower::after,
  .horizontal-line-upper::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: #9e9e9e;
    clip-path: polygon(100% 0%, 0% 50%, 100% 100%);
    bottom: -8px;
  }

  .horizontal-line-upper::after {
    clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  }

  .horizontal-line-lower.top {
    top: 0;
    left: 0;
    transform: translateX(-100%);
  }
  .horizontal-line-upper.top,
  .horizontal-line-upper.middle {
    top: 0;
    left: 0;
    transform: none;
  }

  .horizontal-line-upper.middle {
    top: 73%;
  }

  .horizontal-line-upper.bottom {
    top: unset;
    left: 0;
    bottom: 0;
  }

  .horizontal-line-lower.top::after,
  .horizontal-line-upper.top::after {
    display: none;
  }

  .horizontal-line-lower.middle {
    top: 58%;
    left: 0;
    transform: translate(-100%, -50%);
  }

  .horizontal-line-lower.middle::after,
  .horizontal-line-upper.middle::after {
    top: 58%;
    left: 0;
    transform: translateY(-50%);
  }

  .horizontal-line-lower.upper-middle {
    top: 38%;
    left: 0;
    transform: translate(-100%, -50%);
  }

  .horizontal-line-lower.upper-middle::after {
    top: 38%;
    left: 0;
    transform: translateY(-50%);
  }

  .horizontal-line-lower.lower-middle {
    top: 78%;
    left: 0;
    transform: translate(-100%, -50%);
  }

  .horizontal-line-lower.lower-middle::after {
    top: 78%;
    left: 0;
    transform: translateY(-50%);
  }

  .horizontal-line-lower.bottom {
    top: unset;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
  }

  .horizontal-line-lower.bottom::after,
  .horizontal-line-upper.bottom::after {
    left: 0;
    transform: translateY(-50%);
  }

  .horizontal-line-upper.middle::after,
  .horizontal-line-upper.bottom::after {
    left: unset;
    right: 0;
  }
}
@media (min-width: 961px) and (max-width: 1280px) {
  .horizontal-arrow,
  .vertical-arrow {
    display: none;
  }
  .line-container-mobile-lower,
  .line-container-mobile-upper {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    height: 60%;
    left: 99%;
    top: 31.5%;
  }

  .line-container-mobile-upper {
    top: 9.5%;
    left: 1%;
    height: 33%;
  }

  .vertical-line-lower,
  .vertical-line-upper {
    position: relative;
    width: 2px;
    height: 100%;
    background-color: #9e9e9e;
  }

  .horizontal-line-lower,
  .horizontal-line-upper {
    position: absolute;
    width: 20px;
    height: 2px;
    background-color: #9e9e9e;
  }

  .horizontal-line-upper {
    width: 18px;
  }

  .horizontal-line-lower::after,
  .horizontal-line-upper::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    background-color: #9e9e9e;
    clip-path: polygon(100% 0%, 0% 50%, 100% 100%);
    bottom: -8px;
  }

  .horizontal-line-upper::after {
    clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  }

  .horizontal-line-lower.top,
  .horizontal-line-upper.top {
    top: 0;
    left: 0;
    transform: translateX(-100%);
  }

  .horizontal-line-lower.top::after,
  .horizontal-line-upper.top::after {
    display: none;
  }

  .horizontal-line-lower.middle,
  .horizontal-line-upper.middle {
    top: 58%;
    left: 0;
    transform: translate(-100%, -50%);
  }

  .horizontal-line-lower.middle::after,
  .horizontal-line-upper.middle::after {
    top: 58%;
    left: 0;
    transform: translateY(-50%);
  }

  .horizontal-line-lower.upper-middle {
    top: 38%;
    left: 0;
    transform: translate(-100%, -50%);
  }

  .horizontal-line-upper.middle {
    top: 73%;
  }

  .horizontal-line-upper.bottom {
    top: unset;
    left: 0;
    bottom: 0;
  }

  .horizontal-line-lower.upper-middle::after {
    top: 38%;
    left: 0;
    transform: translateY(-50%);
  }

  .horizontal-line-lower.lower-middle {
    top: 78%;
    left: 0;
    transform: translate(-100%, -50%);
  }

  .horizontal-line-lower.lower-middle::after {
    top: 78%;
    left: 0;
    transform: translateY(-50%);
  }

  .horizontal-line-lower.bottom,
  .horizontal-line-upper.bottom {
    top: unset;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
  }

  .horizontal-line-upper.top,
  .horizontal-line-upper.middle,
  .horizontal-line-upper.bottom {
    transform: none;
  }

  .horizontal-line-lower.bottom::after,
  .horizontal-line-upper.bottom::after {
    left: 0;
    transform: translateY(-50%);
  }

  .horizontal-line-upper.middle::after,
  .horizontal-line-upper.bottom::after {
    left: unset;
    right: 0;
  }
}
</style>
